import { useState, useMemo } from 'react';
import { withAlpha } from './nivoTheme';

type LegendDatum = { id: string | number };

// Replaces Chart.js's legend onHover/onLeave dataset-dimming trick: hovering a legend
// item dims every other series' color, driven by plain React state instead of
// mutating chart internals.
export function useLegendHoverDim(colorMap: Record<string, string>) {
    const [hoveredId, setHoveredId] = useState<string | number | null>(null);

    const colors = useMemo(
        () => (d: { id: string | number }) => {
            const base = colorMap[d.id];
            return hoveredId !== null && d.id !== hoveredId ? withAlpha(base) : base;
        },
        [colorMap, hoveredId]
    );

    const legends = useMemo(
        () => ({
            onMouseEnter: (datum: LegendDatum) => setHoveredId(datum.id),
            onMouseLeave: () => setHoveredId(null)
        }),
        []
    );

    return { hoveredId, colors, legends };
}
